<div bsModal #recommendedDocuments="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width: 1000px;">
        <div class="modal-content" data-bind="with: entity">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                <h3 class="modal-title" id="myModalLabel">
                    Document Association &bull; {{ equipment.Serial }} ({{ poweredBy.Name }})
                </h3>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="panel panel-success" style="margin-bottom:0;">
                            <div class="panel-heading">
                                <h5 style="display: inline-block">
                                    <span class="badge">{{ documents.length }}</span>
                                    <span>Assigned Documents</span>
                                </h5>
                                <div class="pull-right btn-group btn-group-md">
                                    <a class="btn btn-info" title="Remove Selected" (click)="removeSelected()">
                                        <span data-toggle="tooltip" class="fa fa-minus"></span>
                                    </a>
                                    <a class="btn btn-info" title="Select All" (click)="selectAllAssociated()">
                                        <span data-toggle="tooltip" class="fa fa-check-square-o"></span>
                                    </a>
                                </div>
                            </div>
                            <div class="panel-body">
                                <div class="list-group" style="overflow-y:scroll; height: 432px;">
                                    <div class="list-group-item" style="padding: 0;" *ngFor="let document of documents">
                                        <div class="panel-group">
                                            <div class="panel" [class.panel-success]="isAssociatedSelected(document.Id)" (click)="selectAssociated(document.Id)">
                                                <div class="panel-heading" style="padding: 0 0 0 5px;">
                                                    <h5 style="display: inline-block">
                                                        {{ document.FileName }}
                                                        <br />
                                                        {{ document.ProductName }}
                                                    </h5>
                                                    <div class="pull-right" style="padding-right:30px;">
                                                        <h5 class=" label label-info">
                                                            {{ document.Updated | amDateFormat: 'MM/DD/YYYY'  }}
                                                            <br />
                                                            {{ document.Version }}
                                                        </h5>
                                                    </div>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="panel panel-success" style="margin-bottom:0;">
                            <div class="panel-heading">
                                <h5 style="display: inline-block">
                                    <span>Assign Equivalent Translated Documents</span>
                                </h5>
                            </div>
                            <div class="panel-body">
                                <div class="panel-group">
                                    <div class="panel">
                                        <div class="panel-heading" style="padding: 0 0 0 5px;">
                                            <h5 style="display: inline-block">
                                                Base Language
                                            </h5>
                                            <div class="pull-right">
                                                <select name="baseLanguage" class="xor-form-control" id="lstFMILanguage" [(ngModel)]="equipment.BaseLanguage" (change)="baseLanguageChange(equipment.BaseLanguage)">
                                                    <option *ngFor="let language of languages" [value]="language.Name" [selected]="language.Name == equipment.BaseLanguage">{{ language.Name }}</option>
                                                </select>
                                            </div>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="list-group" style="overflow-y:scroll; height: 400px;">
                                    <div class="list-group-item" style="padding: 0;" *ngFor="let language of languages">
                                        <div class="panel-group" *ngIf="language.Available">
                                            <div class="panel">
                                                <div class="panel-heading" style="padding: 0 0 0 5px;">
                                                    <h5 style="display: inline-block">
                                                        {{ language.Name }}
                                                    </h5>
                                                    <div class="pull-right" style="padding-right:30px;">
                                                        <div class="checkbox">
                                                            <label>
                                                                <input type="checkbox" name="{{ language.Name }}" value="{{ language.Name }}" (change)="languageChecked($event)" />
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel-group" *ngIf="!language.Available">
                                            <div class="panel" style="background-color:gainsboro">
                                                <div class="panel-heading" style="padding: 0 0 0 5px;">
                                                    <h5 style="display: inline-block">
                                                        {{ language.Name }}
                                                    </h5>
                                                    <div class="pull-right" style="padding-right:5px;">
                                                        <div class="btn-toolbar pull-right" style="padding-top: 5px" *ngIf="language.Name != equipment.BaseLanguage">
                                                            <div class="btn-group btn-group-md">
                                                                <button type="button" style="margin-right: 2px; padding: 3px 5px;" class="btn btn-primary" title="Clear Documents For {{ language.Name }}" (click)="clearLangDocuments(language.Name)">
                                                                    <span data-toggle="tooltip" class="fa fa-trash-o fa-sm"></span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="checkbox pull-right" *ngIf="language.Name != equipment.BaseLanguage">
                                                            <label>
                                                                <input type="checkbox" name="{{ language.Name }}" checked="{{ language.Available }}" disabled />
                                                            </label>
                                                        </div>
                                                        <div class="checkbox pull-right" style="padding-right:25px;" *ngIf="language.Name == equipment.BaseLanguage">
                                                            <label>
                                                                <input type="checkbox" name="{{ language.Name }}" checked="{{ language.Available }}" disabled />
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>
<div bsModal #modConfirmation="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Confirmation
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">
                            Are you sure you want to add "{{ selectedLanguage  }}" Manuals to {{ equipment.Serial }} ({{ poweredBy.Name }})
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="confirmYes()">Yes</button>
                <button type="button" class="btn btn-primary" (click)="confirmCancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<div bsModal #modConfirmDelete="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Delete Confirmation
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">
                            Are you sure you want to delete "{{ selectedLanguage  }}" Manuals from {{ equipment.Serial }} ({{ poweredBy.Name }})
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="confirmDeleteYes()">Yes</button>
                <button type="button" class="btn btn-primary" (click)="confirmDeleteCancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>